<div class="user-actions d-flex gap-2 justify-content-center align-items-center">
  <svg-icon src="assets/icons/visible.svg"
            class="cursor-pointer action-ic"
            title="Afficher le détail"
            (click)="viewDialog()"></svg-icon>
  @if (canEdit) {
    <svg-icon src="assets/icons/edit-action.svg"
              class="cursor-pointer action-ic"
              title="Modifier"
              (click)="editDialog()"></svg-icon>
  }
  @if (canResend) {
    <svg-icon src="assets/icons/send-mail.svg"
              class="cursor-pointer action-ic"
              title="Renvoyer l'invitation"
              (click)="resendInvitation()"></svg-icon>
  }
  @if (canEnable) {
    <svg-icon src="assets/icons/check-circle-action.svg"
              class="cursor-pointer action-ic"
              title="Réactiver le compte"
              (click)="enable()"></svg-icon>
  }
  @if (canDisable) {
    <svg-icon src="assets/icons/lock-alt.svg"
              class="cursor-pointer action-ic action-ic-lock"
              title="Désactiver le compte"
              (click)="disable()"></svg-icon>
  }
  @if (canDelete) {
    <svg-icon src="assets/icons/trash-red.svg"
              class="cursor-pointer action-ic"
              title="Supprimer"
              (click)="deletePerson()"></svg-icon>
  }
</div>
